/* ig-related.js  v3  2026-08-27
   "You may also like" on the product page.

   Larry, 27 Aug: "please add product you may like as well, then we will
   randomly suggest some other rings within the same series" - then "the
   website should mirror the changes".

   WHY NOT THE THEME'S OWN SECTION
   The theme ships a product-recommendations section, but it is disabled in
   templates/product.json and re-enabling it means rewriting that file - which
   holds a very large custom_liquid block (WhatsApp button, deposit calculator,
   trust strip). Rewriting it by hand risks corrupting live functionality for a
   feature that needs 100 lines. It also renders a Flickity carousel, which is
   not what we want here.

   HOW IT WORKS
   Shopify's own recommendation endpoint picks products that share collections,
   type and vendor with the current one. We ask for the maximum, shuffle, and
   show 4, so a returning visitor sees a different set. Prices come back in the
   visitor's PRESENTMENT currency (verified: the endpoint returned SGD cents on
   an SGD session and USD on a USD one), so no conversion is done here.

   v2 - CATEGORY LOCK. Shopify's "related" intent matched on shape, not
   category: a pear RING was being offered pear studs, a pear tennis bracelet
   and pear drop earrings. Larry asked for other RINGS. Recommendations are now
   filtered to the same category family as the current product. Note the order
   of the tests below - "earring" contains the substring "ring", so earrings
   must be identified first or every earring would read as a ring. Product types
   in this catalogue are inconsistent ("Ring", "Rings", "Eternity Ring", and a
   number are blank), so the title is checked as well as the type.

   If fewer than two survive the filter, the unfiltered set is used instead -
   an empty upsell is worse than a loosely related one.

   v3 - DESKTOP TOO. The max-width:768px gate is gone. Two columns on mobile,
   four on desktop, centred and capped so it does not stretch on a wide screen.

   Product template, all widths. Self-contained - styles are injected here.
   REVERT: delete this file and remove its <script> from snippets/preload.liquid. */
(function () {
  'use strict';

  var ASK = 16;
  var SHOW = 4;
  var HEADING = 'You may also like';

  var done = false;

  /* ORDER MATTERS - earring before ring */
  function family(text) {
    var t = (text || '').toLowerCase();
    if (/earring|stud|huggie|hoop|crawler/.test(t)) return 'earrings';
    if (/bracelet/.test(t)) return 'bracelet';
    if (/necklace|pendant/.test(t)) return 'necklace';
    if (/ring|band/.test(t)) return 'ring';
    return '';
  }

  function familyOf(p) { return family((p.product_type || '') + ' ' + (p.title || '')); }

  function money(cents) {
    var c = (window.Shopify && window.Shopify.currency) || {};
    var code = c.active || 'HKD';
    var opts = { style: 'currency', currency: code, minimumFractionDigits: 0, maximumFractionDigits: 0 };
    try {
      return new Intl.NumberFormat('en', Object.assign({ currencyDisplay: 'narrowSymbol' }, opts)).format(cents / 100);
    } catch (e) {}
    try {
      return new Intl.NumberFormat('en', opts).format(cents / 100);
    } catch (e2) {
      return code + ' ' + Math.round(cents / 100);
    }
  }

  function sized(url, w) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  function shuffle(a) {
    for (var i = a.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var t = a[i]; a[i] = a[j]; a[j] = t;
    }
    return a;
  }

  function style() {
    var s = document.createElement('style');
    s.textContent =
      '.ig-rel{padding:26px 16px 30px;border-top:1px solid #E6E7EB;max-width:1200px;margin:0 auto}' +
      '.ig-rel__h{margin:0 0 16px;font-size:13px;letter-spacing:.12em;text-transform:uppercase;color:#192B54;text-align:center}' +
      '.ig-rel__g{display:grid;grid-template-columns:1fr 1fr;gap:18px 12px}' +
      '.ig-rel__c{display:block;text-decoration:none;color:inherit}' +
      '.ig-rel__i{width:100%;aspect-ratio:1/1;object-fit:cover;background:#F4F5F7;display:block;border-radius:2px;transition:opacity .2s}' +
      '.ig-rel__t{margin:8px 0 4px;font-size:12px;line-height:1.4;color:#3A3A3A;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden}' +
      '.ig-rel__p{font-size:13px;font-weight:600;color:#192B54}' +
      '@media only screen and (min-width:769px){' +
        '.ig-rel{padding:44px 24px 56px}' +
        '.ig-rel__h{font-size:14px;margin-bottom:26px}' +
        '.ig-rel__g{grid-template-columns:repeat(4,1fr);gap:26px 22px}' +
        '.ig-rel__t{font-size:13px;margin-top:12px}' +
        '.ig-rel__p{font-size:14px}' +
        '.ig-rel__c:hover .ig-rel__i{opacity:.85}' +
      '}';
    (document.head || document.documentElement).appendChild(s);
  }

  function render(products) {
    if (!products.length) return;

    var anchor = document.querySelector('.main-product') || document.querySelector('.main__product-inner');
    if (!anchor) return;
    var host = anchor.closest('.shopify-section') || anchor;
    if (!host.parentNode) return;

    style();

    var wrap = document.createElement('section');
    wrap.className = 'ig-rel';

    var h = document.createElement('h2');
    h.className = 'ig-rel__h';
    h.textContent = HEADING;
    wrap.appendChild(h);

    var grid = document.createElement('div');
    grid.className = 'ig-rel__g';

    products.forEach(function (p) {
      var a = document.createElement('a');
      a.className = 'ig-rel__c';
      a.href = p.url;

      var img = document.createElement('img');
      img.className = 'ig-rel__i';
      img.loading = 'lazy';
      img.alt = p.title;
      img.src = sized(p.featured_image, 500);
      a.appendChild(img);

      var t = document.createElement('div');
      t.className = 'ig-rel__t';
      t.textContent = p.title;
      a.appendChild(t);

      var pr = document.createElement('div');
      pr.className = 'ig-rel__p';
      var lo = (p.price_min != null) ? p.price_min : p.price;
      var from = (p.price_min != null && p.price_max != null && p.price_min !== p.price_max);
      pr.textContent = (from ? 'From ' : '') + money(lo);
      a.appendChild(pr);

      grid.appendChild(a);
    });

    wrap.appendChild(grid);
    host.parentNode.insertBefore(wrap, host.nextSibling);
  }

  function meta() {
    try {
      if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product) {
        return window.ShopifyAnalytics.meta.product;
      }
    } catch (e) {}
    return null;
  }

  function currentFamily() {
    var m = meta();
    var type = (m && m.type) || '';
    var title = document.querySelector('.product__title');
    return family(type + ' ' + (title ? title.textContent : document.title));
  }

  function load(id) {
    var fam = currentFamily();
    var url = '/recommendations/products.json?product_id=' + id + '&limit=' + ASK + '&intent=related';
    fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var all = (d && d.products) || [];
        var list = all;
        if (fam) {
          var same = all.filter(function (p) { return familyOf(p) === fam; });
          if (same.length >= 2) list = same;
        }
        render(shuffle(list.slice()).slice(0, SHOW));
      })
      .catch(function () { /* silent - a missing upsell must never break the page */ });
  }

  function run() {
    if (done) return;
    if (document.querySelector('.ig-rel')) { done = true; return; }

    var m = meta();
    if (m && m.id) { done = true; load(m.id); return; }

    fetch(window.location.pathname + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (p) { if (p && p.id && !done) { done = true; load(p.id); } })
      .catch(function () {});
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  window.addEventListener('load', run);
}());
